export default __webpack_public_path__ + "static/media/ic_cash.21569a1d.svg";